export default __webpack_public_path__ + "static/media/icon-documents.c5300d18.svg";